"use client";

import Button from "react-bootstrap/Button";

import "../styles/result-card-grid.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useFullScreen } from "../contexts/FullScreenProvider";

export const CardEducationInfo = ({ educations }) => {
  const { isFullScreen } = useFullScreen();
  if (!educations || educations.length === 0) {
    return (
      <div className="info-item d-flex align-items-center mb-2">
        <i
          className="fas fa-graduation-cap mr-2"
          style={{ fontSize: "12px" }}
        />
        <span
          className="info-text"
          style={{ fontSize: "0.85rem", color: "#495057" }}
        >
          N/A
        </span>
      </div>
    );
  }

  return (
    <div className="info-item d-flex align-items-center mb-2">
      <i
        className="fas fa-graduation-cap mr-2"
        style={{ fontSize: "12px", marginBottom: "auto", paddingTop: "4px" }}
      />
      <div
        className="info-text d-flex flex-column"
        style={{ fontSize: "0.85rem", color: "#495057" }}
      >
        <p style={{ marginBottom: "0" }}>{educations[0].full_name}</p>
        <div>
          {educations.length > 1 && (
            <OverlayTrigger
              trigger={["click", "hover", "focus"]}
              placement="auto"
              rootClose
              overlay={
                <Popover
                  id="education-popover"
                  className={isFullScreen ? "popover-fullscreen" : ""}
                >
                  <Popover.Title as="h3">
                    <i className="fa fa-graduation-cap mr-2" />
                    Other Education
                  </Popover.Title>
                  <Popover.Content>
                    <ul style={{ paddingLeft: 18, margin: 0 }}>
                      {educations.slice(1).map((edu, idx) => (
                        <li key={edu.id || idx}>{edu.full_name}</li>
                      ))}
                    </ul>
                  </Popover.Content>
                </Popover>
              }
            >
              <Button
                variant="link"
                size="sm"
                className="p-0 ms-2"
                style={{
                  fontSize: "0.8em",
                  color: "#17a2b8",
                  textDecoration: "underline",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                View {educations.length - 1} more
              </Button>
            </OverlayTrigger>
          )}
        </div>
      </div>
    </div>
  );
};
